export const fulfillmentLabels = {
    SHIP_TO_HOME_OR_STORE_LABEL: 'Ship to Home or Store',
    SHIP_TO_HOME_ONLY_LABEL: 'Ship to Home Only',
    FREE_SAME_DAY_PICKUP_LABEL: 'Same Day Pickup',
    TRUCK_DELIVERY_LABEL: ' Truck Delivery',
    DELIVERY_FEE_MAY_APPLY_LABEL: 'Delivery fee may apply.',
    RECYCLE_FEE_MAY_APPLY_LABEL: 'Recycle fee may apply.',
    DELIVERY_FEE_AND_OR_RECYCLE_FEE_MAY_APPLY_LABEL: 'Recycle and/or delivery fee may apply.',
    OUT_OF_STOCK_ONLINE_LABEL: 'Out of Stock Online',
    OUT_OF_STOCK_ONLINE_MESSAGE: 'Please visit store for purchase',
    FREE_PICKUP: 'FREE Pickup',
};

export const giftCardLabels = {
    GIFT_CARD_PAGE_TITLE: 'Check Gift Card Balance',
};
export const signInPageLabels = {
    CREATE_ACCOUNT_TITLE: 'Create Account',
    CREATE_ACCOUNT_SUBTITLE: 'Earn JCPenney Rewards points',
    CREATE_ACCOUNT_SUBTITLE_NEW: 'Start earning JCPenney Rewards points',
    AGREEMENT_FIRST: 'By creating an account, I agree to the Rewards',
    AGREEMENT_SECOND: 'and to receive email offers at the email address I provided.',
    AGREEMENT_URL: 'https://www.jcpenney.com/m/rewards-terms-and-conditions',
};

export const cartPageMsg = {
    upsellErrorMsg: 'Currently, no parts or services are available for this product',
    OK_BTN_LABLE: 'Ok',
};
export const singleClickCheckout = {
    CLOSE_LINK_TXT: 'Back to Cart',
};

export const SVC_ORD_ERR_INV_NF = 'SVC_ORD_ERR_INV_NF';

export const giftCardRegularItemErrorCodes = {
    SRV_BAG_GIFT_CARD_WITH_GIFT_CARD: 'SRV_BAG_GIFT_CARD_WITH_GIFT_CARD',
    SVC_ORD_ERR_MERCHANDISE_NOTALLOWED: 'SVC_ORD_ERR_MERCHANDISE_NOTALLOWED',
};

export const deliveryChangedLabels = {
    DELIVERY_METHODS_CHANGED_SINGLE:
        'item has a delivery method change, because of inventory availability:',
    DELIVERY_METHODS_CHANGED_MULTIPLE:
        'items have delivery method changes, because of inventory availability:',
    MESSAGE_ABOUT_CART: 'Important message about your cart',
};
